import { observable, runInAction, action, computed } from 'mobx'
import { get, json } from '../../../../utils/ajax'
import { objToValueObj, ValueObjToObj,handleSearchAndPage, setStore } from "../../../../utils/Utils"
import { message } from 'antd'

class CarseriesStore {
    @observable carList //车系列表
    @observable searchCondition //查询条件
    @observable pagination //车系分页
    @observable carLoading   //车系加载loading
    @observable isShowEditModal //是否显示编辑模态框
    @observable editCar   //保存当前编辑的车系
    @observable carInfo   //车系编辑信息
    @observable brands   //车系下拉列表项
    @observable carInfoData   //修改回显数据
    @observable editTitle  //根据不同的选择显示相应的模态框名
    @observable isShowForm   //判断车系管理里面中英文切换的显示
    @observable searchLang   //搜索用的选择版本

    constructor () {
        this.carList = []
        this.searchCondition = {
            defaultNameOrCode: '',
            language: ''
        }
        this.pagination = {
            current: 0,
            total: 1,
            showQuickJumper:true,
            showSizeChanger:true,
            pageSize:10,
            showTotal:()=>{}
        }
        this.carLoading = false
        this.isShowEditModal = false
        this.editCar = {}
        this.carInfo = {
            icon: {},
            language: '',
            carBrandId: {},
            carSeriesCode: {},
            defaultName: {},
            defaultDescription: {},
            rank:{},
            modifiableCarCode:{}
        }
        this.brands = []
        this.carInfoData=[]
        this.editTitle = ''
        this.isShowForm = 1
        this.searchLang = ''
    }

    /**
     * 选中的车系列表
     */
    @computed
    get selectList () {
        return this.carList.filter(item => item.checked)
    }

    /**调用setStore方法并传入当前this***/
    @action
    setStore = (obj) => {
        setStore(obj, this)
    }

    /**
     * 获取车系列表
     * @param page
     * @returns {Promise.<void>}
     */
    @action
    initPage = async (page) => {
        this.carLoading = true
        if (this.searchLang) {
            this.searchCondition.language = this.searchLang
        } else {
            this.searchCondition.language = ''
        }
        const search = handleSearchAndPage(page, this.pagination, this.searchCondition);
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseCarSeries/carseries:search`, search)
        if (res && res.status === 0) {
            runInAction(() => {
                this.loading = false
            })
            return
        }
        runInAction(() => {
            this.pagination = {
                current: res.number+1,
                total: res.totalElements,
                showQuickJumper:true,
                showSizeChanger:true,
                pageSize:res.size,
                showTotal:()=>`总共 ${res.totalElements} 条`
            }
            let carList1 = res.content || []
           carList1.map((item,index)=>{
            return item.index=index
            })
            this.carList=carList1
            this.carLoading = false
        })
    }

    /**
     * 选中车系
     * @param brand
     */
    @action
    selectCarseries = (brand) => {
        let list = this.carList.slice()
        const index = list.findIndex(item => item.id === brand.id)
        this.carList[index].checked = !this.carList[index].checked
    }
    /**
     * 批量切换车系启用/停用
     * @param state 1 启用 0 停用
     * @returns {Promise.<void>}
     */
    @action
    toggleCarseriesStatus = async (state) => {
        const list = this.selectList.map(item => ({...item, state}))
        this.carLoading = true
        await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseCarSeries/update/batch`, list)
        await this.initPage(this.pagination.current)
        message.success(state ? '启用成功' : '停用成功')
    }
    /**
     * 批量删除车系
     */
    @action
    deleteCarseries = async () => {
        const ids = this.selectList.map(item => item.id)
        await json.batchDelete(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseCarSeries/delete/batch`, ids)
        if(this.carList.length-ids.length===0){
            let currentPage = this.pagination.current-1
            await this.initPage(currentPage)
        }else {
            await this.initPage(this.pagination.current)
        }
        message.success('删除成功')
    }
    /**
     * 搜索绑值
     * @param valuey
     */
    @action
    onSearchChange = (value) => {
        this.searchCondition = {
            defaultNameOrCode: value
        }
    }
    /**
     * 打开编辑/新增模态框
     */
    @action
    openEditModal = async (editCar = {}) => {
        this.isShowEditModal = true
        this.editCar = editCar
        this.clearBrandInfo()
        this.brands=[]
        //获取下拉框的值
        json.get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseBrand/get/all`).then(res=>{
            runInAction(()=>{
                res.forEach((item,index)=>{
                    this.brands.push(item)
                })
            })
        })
        //编辑需要回显
        if (editCar.id) {
            const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseCarSeries/get/${editCar.id}`)
            runInAction(() => {
                this.carInfoData = Array.isArray(res)?res:[]
                this.carInfo = objToValueObj(res[0])
                this.isShowForm = this.carInfo.language.value
            })
        }
    }
    /**
     * 关闭编辑/新增模态框
     */
    @action
    closeEditModal = () => {
        this.isShowEditModal = false
        this.isShowForm = 1
    }
    /**
     * 编辑/新增模态确定
     */
    @action
    confirmEdit = async () => {
        // if (this.isShowForm === 1) {
        //     this.carInfo.enName = ''
        //     this.carInfo.enDescribe = ''
        // }
        // if (this.isShowForm === 2) {
        //     this.carInfo.defaultName = ''
        //     this.carInfo.defaultDescription = ''
        // }
        this.carLoading = true
        const carInfo = ValueObjToObj(this.carInfo)
        if (this.editCar.id) {
            const res = await json.put(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseCarSeries/update`, carInfo)    //修改
            res.status === 1 && message.success('修改成功')
        } else {
            const res = await json.post(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseCarSeries/add`, ValueObjToObj(this.carInfo))    //新增
            res.status === 1 && message.success('新增成功')
        }
        this.carLoading = false
        this.closeEditModal()
        this.initPage(this.pagination.current)

    }
    /**
     * 车系编辑框表单绑值
     * @param changedFields
     */
    @action
    onFieldsChange = (changedFields) => {
        this.carInfo = {...this.carInfo, ...changedFields}
    }
    /**
     * 清空车系表单的值
     */
    @action
    clearBrandInfo = () => {
        let obj = {}
        for (let key of Object.keys(this.carInfo)) {
            obj[key] = {}
        }
        this.carInfo = obj
    }
    /**
     * 校验车系代码是否重复
     * @param rule
     * @param value
     * @param callback
     */
    checkBrandCode = async (rule, value, callback) => {
        if(this.editCar.id){
            if(this.carInfoData[0].modifiableCarCode!==this.carInfo.modifiableCarCode.value) {
                const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseCarSeries/get/codeOrName/${value}`)
                let isCode = res.find(i => i.modifiableCarCode === value);
                if (isCode) {
                    //编辑的时候不去校验
                    callback('车系代码不能重复')
                }
                callback()
            }
        }else {
            const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseCarSeries/get/codeOrName/${value}`)
            let isCode = res.find(i => i.modifiableCarCode === value);
            if (isCode) {
                //编辑的时候不去校验
                callback('车系代码不能重复')
            }
            callback()
        }

        callback()
    }
    /**
     * 校验车系名是否重复
     * @param rule
     * @param value
     * @param callback
     */
    checkDefaultName = async (rule, value, callback) => {
        const res = await get(`${process.env.REACT_APP_API_URL}/onestep/base/customerService/carBasicData/carBaseCarSeries/get/codeOrName/${value}`)
        if (!this.editCar.id && res.content && res.content.length) {
            callback('车系名不能重复')
        }
        callback()
    }

    /**
     * 图片上传
     */
    @action imageUpload = (info) => {
        runInAction(() => {
            this.btnLoading = true
        })
        if (info.file.status === 'done') {
            info = info.file.response
            runInAction(() => {
                this.btnLoading = false
            })
            return
        } else if (info.file.status === 'error') {
            runInAction(() => {
                this.btnLoading = false
            })
            message.error(`${info.file.name} 上传失败`)
        }
    }

}

export default new CarseriesStore()


// WEBPACK FOOTER //
// ./src/Backend/sparePartsCatalogue/basicDataOfAutomobile/Carseries/store.js